import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

declare let window: any;

@Component({
  selector: "app-paginacao",
  templateUrl: "./paginacao.component.html",
  styleUrls: ["./paginacao.component.css"]
})
export class PaginacaoComponent implements OnInit, OnChanges {
  @Input() mostrarPaginacao: boolean = true;
  @Input() limit: number = 7;
  @Input() items_per_page: number;
  @Input() total_items: number;
  @Input() total_pages: number;
  @Input() page: number;

  public pagIni: boolean = true;
  public pagFim: boolean = true;
  public showPages: Array<any> = [];

  get hasPrevPage() {
    return this.page === 1;
  }

  get hasNextPage() {
    return this.page === this.total_pages;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  public atualizarPagings() {
    let pagIni = 1;
    let pagFim = 1;

    pagFim = this.limit < this.total_pages ? this.limit : this.total_pages;

    if (this.total_pages > this.limit) {
      let parte = parseInt((this.limit / 2).toString());

      if (this.page > parte) {
        pagIni = this.page - parte;
        pagFim = this.page - parte + this.limit - 1;

        if (this.page + parte > this.total_pages) {
          pagIni = this.total_pages - this.limit + 1;
          pagFim = this.total_pages;
        }
      }
    }

    this.showPages = [];
    for (let i = pagIni; i <= pagFim; i++) {
      this.showPages.push(i);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.atualizarPagings();
  }

  public ngOnInit() {}

  public navegar(pageParams?: any) {
    this.route.queryParams
      .subscribe((params: any) => {
        let queryParams = Object.assign({}, params, pageParams);
        this.router.navigate([], { queryParams });
      })
      .unsubscribe();

    "scrollTo" in window && window.scrollTo(0, 300);
  }

  public showNavPag(page: number) {
    return this.showPages.indexOf(page) < 0;
  }
}
